/* eslint-disable @typescript-eslint/no-explicit-any */
import type { RegisteredEditorModule } from './types';
import { crosswordModule } from './modules/crossword';
import { wordsearchModule } from './modules/wordsearch';
import { sudokuModule } from './modules/sudoku';
import { rebusModule } from './modules/rebus';
import { traditionalModule } from './modules/traditional';

// kind → módulo. Um lugar só para o shell resolver o tipo de jogo da rota. Novos
// tipos (caça-palavras, sudoku, rébus) entram aqui, sem tocar no shell.
//
// O valor é `RegisteredEditorModule<any, any>`: cada módulo é fortemente tipado no seu
// próprio doc/action, mas o registro heterogêneo precisa apagar os genéricos (o shell
// trata tudo pela abstração). O que o registro NÃO apaga é o `entry`: é aqui — e só
// aqui — que o compilador cobra o ponto de entrada de quem entra no catálogo.

const modules: Record<string, RegisteredEditorModule<any, any>> = {
  [crosswordModule.kind]: crosswordModule,
  [wordsearchModule.kind]: wordsearchModule,
  [sudokuModule.kind]: sudokuModule,
  [rebusModule.kind]: rebusModule,
  [traditionalModule.kind]: traditionalModule,
};

/** Rótulo do botão de editor no catálogo quando o módulo não declara outro. */
export const DEFAULT_EDIT_LABEL = 'Editar grade';

export function getModule(kind: string): RegisteredEditorModule<any, any> | undefined {
  return modules[kind];
}

/** Todos os módulos registrados, na ordem de registro. É daqui que a UI monta a
 *  lista de tipos do assistente — nada de enumerar tipos à mão. */
export function listModules(): RegisteredEditorModule<any, any>[] {
  return Object.values(modules);
}

/** O módulo que edita este estilo de PASSATEMPO, se houver. `null` casa só se algum
 *  módulo o declarar; desconhecido = a linha não tem editor (o catálogo cai no "Regerar"). */
export function getModuleForPassatempo(
  estilosDePassatemposId: number | null | undefined,
): RegisteredEditorModule<any, any> | undefined {
  const estilo = estilosDePassatemposId ?? null;
  return listModules().find(
    (m) =>
      m.entry.catalog === 'passatempo' && m.entry.estilosDePassatemposIds.includes(estilo),
  );
}

/** O módulo que edita este tipo de JOGO, se houver. */
export function getModuleForJogo(
  idTipo: number | null | undefined,
): RegisteredEditorModule<any, any> | undefined {
  if (idTipo == null) return undefined;
  return listModules().find((m) => m.entry.catalog === 'jogo' && m.entry.idTipo === idTipo);
}

/** O rótulo do botão que abre o editor a partir do catálogo. O default vive aqui, e
 *  não duplicado nos dois catálogos: um tipo sem grade (rébus) declara o seu em
 *  `entry.editLabel` sem que ninguém precise editar catálogo nenhum. */
export function getEditLabel(module: RegisteredEditorModule<any, any>): string {
  return module.entry.editLabel ?? DEFAULT_EDIT_LABEL;
}
